export default __webpack_public_path__ + "static/media/264828__cmdrobot__text-message-or-videogame-jump.767bbb23.mp3";